function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Proceq_GM_Rounded"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1240,
  height: 1240
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Proceq_GM_Rounded",
  "data-name": "Proceq GM \\u2013 Rounded",
  clipPath: "url(#clip-Proceq_GM_Rounded)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1240,
  height: 1240,
  fill: "rgba(255,255,255,0)"
}), /*#__PURE__*/React.createElement("g", {
  id: "App_Rounded",
  "data-name": "App Rounded"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 1240,
  height: 1240,
  rx: 212,
  fill: "#009ca6"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_74",
  "data-name": "Group 74"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(-46)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M502.828,291.164h-50.7a50.15,50.15,0,0,0-22.312,5.143,61.226,61.226,0,0,0-18.89,14.091c-.994,1.051-1.778,2.409-2.7,3.575q-14.655,16.863-15.621,40.514c-.076,1.071-.191,2.122-.191,3.231V565.851a67.552,67.552,0,0,0,5.181,26.1c.364.822.822,1.568,1.243,2.409.574,1.281,1.224,2.523,1.931,3.766a68.846,68.846,0,0,0,10.152,15.028,61.355,61.355,0,0,0,18.89,14.129c7.074,3.423,15.448,6.615,23.229,6.615H704.613v34.492c0,15.047-7.494,22.58-22.56,22.58H504.836v88.2H748.607c18.622,0,34.51-5.143,47.492-15.371q19.474-15.429,19.483-43.4V291.164ZM704.174,441.423V520.06c0,15.468-6.9,23.9-20.668,23.9l-67.587-.018H525.466c-13.767,0-20.63-6.329-20.63-21.834V404.178q0-23.317,20.63-23.345h158.04q20.649,0,20.668,23.345Z",
  transform: "translate(-217.415 159.836)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_15",
  "data-name": "Group 15",
  transform: "translate(-33)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(467 75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M184.257,139.526H292.172V-109.291h58.819c14.9,0,22.357,7.175,22.357,21.6V139.526h102.76V-109.291h65.58c14.917,0,22.338,7.175,22.338,21.6V139.526H673.584V-130.949c0-9.479-1.68-19.393-5.06-27.286a75.986,75.986,0,0,0-13.2-20.96,57.867,57.867,0,0,0-18.958-14.181,50.16,50.16,0,0,0-21.6-5.1H491.007q-27.729,0-47.018,18.958C431.13-166.94,424.71-149.87,424.71-130.949a69.983,69.983,0,0,0-5.023-26.606,74.2,74.2,0,0,0-13.558-20.96c-5.646-6.1-11.972-11.481-18.939-14.861a48.22,48.22,0,0,0-21.3-5.1H240.15c-1.7.076-3.323.453-5,.661a47.065,47.065,0,0,0-14.5,4.1,60.655,60.655,0,0,0-18.335,13.671,68.777,68.777,0,0,0-13.048,20.752,64.668,64.668,0,0,0-5,25.114l-.056.245V-80.91h.056Z",
  transform: "translate(-9.201 574.475)",
  fill: "#fff"
})))));

function SvgAppIconGprMounted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1240,
    height: 1240,
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconGprMounted);
export default __webpack_public_path__ + "static/media/appIconGPRMounted.eb8055da.svg";
export { ForwardRef as ReactComponent };